import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const OrganizerTeamTab = ({
  staffList,
  showStaffForm,
  setShowStaffForm,
  staffForm,
  setStaffForm,
  handleAddStaff,
  handleRemoveStaff
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Mon équipe</h3>
        <Button size="sm" onClick={() => setShowStaffForm(true)}>
          <Plus className="w-4 h-4 mr-2" />
          Ajouter un membre
        </Button>
      </div>

      {/* Roles explanation */}
      <div className="glass-card rounded-lg p-4 text-sm">
        <h4 className="font-medium mb-2">Rôles disponibles :</h4>
        <div className="space-y-1 text-muted-foreground text-xs">
          <p><span className="font-medium text-red-500">Admin</span> : Accès complet (créer événements, gérer équipe, voir ventes)</p>
          <p><span className="font-medium text-yellow-500">Vendeur</span> : Voir les ventes et statistiques uniquement</p>
          <p><span className="font-medium text-green-500">Scanner</span> : Scanner les billets à l'entrée uniquement</p>
        </div>
      </div>

      {/* Staff List */}
      {staffList.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          Aucun membre dans votre équipe
        </div>
      ) : (
        <div className="space-y-2">
          {staffList.map((staff) => (
            <div key={staff.id} className="glass-card rounded-lg p-4 flex items-center justify-between">
              <div>
                <h4 className="font-medium">{staff.name}</h4>
                <p className="text-sm text-muted-foreground">{staff.email}</p>
              </div>
              <div className="flex items-center gap-3">
                <span className={`text-xs px-2 py-1 rounded font-medium ${
                  staff.role === 'admin' ? 'bg-red-500/20 text-red-500' :
                  staff.role === 'seller' ? 'bg-yellow-500/20 text-yellow-500' :
                  'bg-green-500/20 text-green-500'
                }`}>
                  {staff.role === 'admin' ? 'Admin' : staff.role === 'seller' ? 'Vendeur' : 'Scanner'}
                </span>
                <Button variant="ghost" size="icon" onClick={() => handleRemoveStaff(staff.id)}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add Staff Form Modal */}
      {showStaffForm && (
        <div className="glass-card rounded-lg p-4 border border-primary/30">
          <h4 className="font-medium mb-4">Ajouter un membre</h4>
          <form onSubmit={handleAddStaff} className="space-y-4">
            <div>
              <Label>Nom</Label>
              <Input
                value={staffForm.name}
                onChange={(e) => setStaffForm({ ...staffForm, name: e.target.value })}
                placeholder="Jean Dupont"
                required
                className="mt-1"
              />
            </div>
            <div>
              <Label>Email</Label>
              <Input
                type="email"
                value={staffForm.email}
                onChange={(e) => setStaffForm({ ...staffForm, email: e.target.value })}
                placeholder="jean@example.com"
                required
                className="mt-1"
              />
            </div>
            <div>
              <Label>Rôle</Label>
              <Select
                value={staffForm.role}
                onValueChange={(value) => setStaffForm({ ...staffForm, role: value })}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="scanner">Scanner (entrée)</SelectItem>
                  <SelectItem value="seller">Vendeur (ventes)</SelectItem>
                  <SelectItem value="admin">Admin (tout)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="flex gap-2">
              <Button type="button" variant="outline" onClick={() => setShowStaffForm(false)} className="flex-1">
                Annuler
              </Button>
              <Button type="submit" className="flex-1">
                Ajouter
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};
